export const CREATE_BOOKING_EXPERIENCE_CONTACT_ENDPOINT = '/booking-portal/ContactV2/CreateContactBookExperience';
